import analytics from './Analytics.utils'

const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE': {
      if (!action.payload.hash) {
        setTimeout(analytics.page, 200)
      }
      return state
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Analytics/Analytics.reducer.js